import { cn } from '../../lib/utils'

/** Stored HTML, rendered.
 *
 * Bodies are sanitised with bleach on write (SPEC section 10), so the stored
 * value is already safe and this renders it rather than re-escaping it. The
 * child selectors exist because the HTML arrives unclassed from the sanitiser.
 */
export function RichText({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={cn(
        'max-w-none text-sm leading-relaxed text-foreground',
        '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
        '[&_p]:mb-2 [&_p:last-child]:mb-0',
        '[&_ol]:mb-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:mb-2 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs',
        '[&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
